/**
 * surface — rilevamento della SUPERFICIE d'uso del tool.
 *
 * 'lim'      = lavagna interattiva / grande schermo in aula (proiezione).
 * 'personal' = PC / tablet / telefono (uso individuale).
 *
 * Esito su <html data-surface="lim"> (assente su personal). NB: è DIVERSO da
 * data-display (toggle Testo/Mappa): qui cambia la SCALA, non la vista.
 */

export type Surface = 'lim' | 'personal';

export function detectSurface(): Surface {
  const param = new URLSearchParams(window.location.search).get('surface');
  if (param === 'lim') return 'lim';
  if (param === 'personal' || param === 'desktop') return 'personal';

  const big = Math.min(window.screen.width, window.innerWidth) >= 1280;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const noHover = window.matchMedia('(hover: none)').matches;
  return big && coarse && noHover ? 'lim' : 'personal';
}

/** Applica l'esito su <html>. Da chiamare PRIMA del boot della shell. */
export function applySurface(): Surface {
  const s = detectSurface();
  if (s === 'lim') document.documentElement.dataset.surface = 'lim';
  else delete document.documentElement.dataset.surface;
  return s;
}

export function isLimSurface(): boolean {
  return document.documentElement.dataset.surface === 'lim';
}
